import { useEffect, useState } from 'react';
import { ReactComponent as CloseSvg } from '../../assets/svg/closeCircle.svg';
import Notification from './notification';
import request from '../../lib/request';

const Dialog = ({
  dialogRef,
  closeDialog,
  notification,
  currentNav,
  handleCurrentNav,
  getNotification,
  isDialogOpen,
}) => {
  const [systemNotification, setSystemNotification] = useState([]);

  useEffect(() => {
    if (isDialogOpen) {
      getSystemNotification();
    }
  }, [isDialogOpen]);

  const getSystemNotification = async () => {
    try {
      const { result } = await request.get('/notification/system');
      if (result?.length > 0) {
        setSystemNotification(result);
      }
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <dialog
      ref={dialogRef}
      className='w-full h-full max-w-lg max-h-dvh p-4'
    >
      <div className='flex justify-end'>
        <button onClick={closeDialog}>
          <CloseSvg />
        </button>
      </div>
      <ul className='flex justify-center items-center gap-8 mb-6'>
        <li className='relative cursor-pointer border-black font-bold'>
          Notifications
        </li>
      </ul>
      <Notification
        notification={notification}
        currentNav={currentNav}
        handleCurrentNav={handleCurrentNav}
        closeDialog={closeDialog}
        getNotification={getNotification}
        systemNotification={systemNotification}
      />
    </dialog>
  );
};

export default Dialog;
